import { convertDatesToISO, getHeaders } from '@/config/aux'
import { DeviceSettings } from '../models/deviceSettings'
import { DeviceSettingsStateType } from './state'
import axios from 'axios'

export interface DeviceSettingsActionsType {
  getDeviceSettings(): Promise<void>
  getDeviceSettingsByDeviceId(deviceId: string): Promise<void>
  postDeviceSettings(deviceSettings: DeviceSettings): Promise<void>
  putDeviceSettings(deviceSettings: DeviceSettings): Promise<void>
  deleteDeviceSettings(id: string): Promise<void>
}

export const DeviceSettingsActions: DeviceSettingsActionsType = {
  async getDeviceSettings(this: DeviceSettingsStateType) {
    try {
      this.deviceSettings = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-settings`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((settings: DeviceSettings) => {
            this.deviceSettings.push(settings)
          })
        }
      })
    } catch (error) {
      console.error('Error getting DeviceSettings', error)
    }
  },
  async getDeviceSettingsByDeviceId(this: DeviceSettingsStateType, deviceId: string) {
    try {
      this.deviceSettings = []
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-settings/device/${deviceId}`
      await axios.get(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          response.data.forEach((settings: DeviceSettings) => {
            this.deviceSettings.push(settings)
          })
        }
      })
    } catch (error) {
      console.error('Error getting DeviceSettings by deviceId', error)
    }
  },
  async postDeviceSettings(this: DeviceSettingsStateType, deviceSettings: DeviceSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-settings`
      const data = convertDatesToISO(deviceSettings.toPlainObject())

      await axios.post(query, data, { headers: getHeaders() }).then(response => {
        if (response.status === 201) {
          // this.deviceSettings.push(deviceSettings)
        }
      })
    } catch (error) {
      console.error('Error posting DeviceSettings', error)
    }
  },
  async putDeviceSettings(this: DeviceSettingsStateType, deviceSettings: DeviceSettings) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-settings`
      const data = convertDatesToISO(deviceSettings.toPlainObject())

      await axios
        .put(query, data, {
          headers: {
            ...getHeaders(),
            'Content-Type': 'application/json',
          },
        })
        .then(response => {
          if (response.status === 200) {
            //this.deviceSettings = this.deviceSettings.map(s => (s.id === deviceSettings.id ? deviceSettings : s))
          }
        })
    } catch (error) {
      console.error('Error updating DeviceSettings', error)
    }
  },
  async deleteDeviceSettings(this: DeviceSettingsStateType, id: string) {
    try {
      const query = `${process.env.VUE_APP_URL_BASE}/api/admin/device-settings/${id}`
      await axios.delete(query, { headers: getHeaders() }).then(response => {
        if (response.status === 200) {
          //this.deviceSettings = this.deviceSettings.filter(s => s.id !== id)
        }
      })
    } catch (error) {
      console.error('Error deleting DeviceSettings', error)
    }
  },
}
